import React, { useEffect } from "react";
import "./ContratType.css";

export default function ContratCDDTempsPleinBTP({
  formData,
  setFormData,
  include,
  handleInputChange,
  handleCheckbox,
  convertirMontantEnLettres,
  initialiserArticlesTexte,
  toggleTextarea,
  shownTextareas,
}) {
  const nomsArticles = {
    article1: "DISPOSITIONS CONVENTIONNELLES APPLICABLES",
    article2: "EMPLOI - FONCTION",
    article3: "PERIODE D’ESSAI",
    article4: "SANS PERIODE D’ESSAI",
    article5: "LIEU DE TRAVAIL",
    article6: "CLAUSE DE MOBILITES",
    article7: "DUREE DU TRAVAIL ET HORAIRE",
    article8: "REMUNERATION",
    article9: "TREIZIEME MOIS",
    article10: "INDEMNITE DE FIN DE CONTRAT",
    article11: "CONGES PAYES",
    article12: "ABSENCE",
    article13: "RETRAITE COMPLEMENTAIRE",
    article14: "MUTUELLE D’ENTREPRISE",
    article15: "DECLARATION SOCIALE NOMINATIVE",
    article16: "TRAITEMENT DES DONNEES PERSONNELLES",
    article17: "OBLIGATIONS DE LOYAUTE",
    article18: "OBLIGATIONS DE CONFIDENTIALITE",
    article19: "EXCLUSIVITE – NON-CONCURRENCE",
    article20: "AUTRES OBLIGATIONS PROFESSIONNELLES",
    article21: "UTILISATION DES OUTILS INFORMATIQUES",
    article22: "VEHICULE DE SERVICE",
    article23: "VEHICULE DE FONCTION",
    article24: "MISE A DISPOSITION GRATUITE D’UN LOGEMENT DEFONCTION",
    article25: "CLAUSE DE CONFIDENTIALITE",
    article26: "CLAUSE DE DEDIT FORMATION",
    article27: "CLAUSE RELATIVE AUX INVENTIONS DES SALARIES",
    article28: "RENOUVELLEMENT",
  };

  useEffect(() => {
    const heuresSemaine = parseFloat(formData.heure_semaine);
    if (!isNaN(heuresSemaine)) {
      const heuresMois = (heuresSemaine * 52) / 12;
      let formatted = heuresMois.toFixed(2).replace(".", ",");
      if (formatted.endsWith(",00")) {
        formatted = formatted.split(",")[0];
      }
      setFormData((prev) => ({
        ...prev,
        heure_mois: formatted,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        heure_mois: "",
      }));
    }
  }, [formData.heure_semaine, setFormData]);

  return (
    <>
      {/* Formulaire Contrat CDI Templs Plein  */}
      <div>
        <h2>Contrat de travail type CDD - temps plein - BTP</h2>
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            gap: "1%",
          }}
        >
          <div>
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                alignItems: "center",
                gap: "2%",
              }}
            >
              <h3>Liste des Articles :</h3>
            </div>

            <div
              style={{
                marginBottom: 20,
              }}
            >
              {Object.keys(nomsArticles).map((key) => (
                <div
                  key={key}
                  style={{
                    marginBottom: "1px",
                  }}
                >
                  {/* Partie gauche : checkbox + label + bouton */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      minWidth: "300px",
                    }}
                  >
                    <input
                      type="checkbox"
                      name={key}
                      checked={include[key]}
                      onChange={handleCheckbox}
                    />
                    <span style={{ margin: "0 10px", fontSize: "10px" }}>
                      {nomsArticles[key]}
                    </span>
                    <button
                      type="button"
                      onClick={() => toggleTextarea(key)}
                      style={{
                        fontSize: "10px",
                      }}
                    >
                      {shownTextareas[key] ? "-" : "+"}
                    </button>
                  </div>

                  {/* Partie droite : textareas conditionnels */}
                  {shownTextareas[key] && (
                    <div style={{ marginLeft: "20px", flex: 1 }}>
                      {key === "article1" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article1_texte"
                            value={
                              formData.article1_texte ||
                              initialiserArticlesTexte(formData).article1_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article1_texteprt1"
                            value={
                              formData.article1_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article1_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article1_texteprt2"
                            value={
                              formData.article1_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article1_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article2" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="cdd_article2_texte"
                            value={
                              formData.cdd_article2_texte ||
                              initialiserArticlesTexte(formData)
                                .cdd_article2_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="cdd_article2_texteprt1"
                            value={
                              formData.cdd_article2_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .cdd_article2_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="cdd_article2_texteprt2"
                            value={
                              formData.cdd_article2_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .cdd_article2_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article3" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article3_texte_cdd"
                            value={
                              formData.article3_texte_cdd ||
                              initialiserArticlesTexte(formData)
                                .article3_texte_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article3_texteprt0_cdd"
                            value={
                              formData.article3_texteprt0_cdd ||
                              initialiserArticlesTexte(formData)
                                .article3_texteprt0_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article3_texteprt1_cdd"
                            value={
                              formData.article3_texteprt1_cdd ||
                              initialiserArticlesTexte(formData)
                                .article3_texteprt1_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article3_texteprt2_cdd"
                            value={
                              formData.article3_texteprt2_cdd ||
                              initialiserArticlesTexte(formData)
                                .article3_texteprt2_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article3_texteprt3_cdd"
                            value={
                              formData.article3_texteprt3_cdd ||
                              initialiserArticlesTexte(formData)
                                .article3_texteprt3_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article3_texteprt4_cdd"
                            value={
                              formData.article3_texteprt4_cdd ||
                              initialiserArticlesTexte(formData)
                                .article3_texteprt4_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article4" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article4_texte_cdd"
                            value={
                              formData.article4_texte_cdd ||
                              initialiserArticlesTexte(formData)
                                .article4_texte_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article5" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article6_texteBTP"
                            value={
                              formData.article6_texteBTP ||
                              initialiserArticlesTexte(formData)
                                .article6_texteBTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article6_texteprt1BTP"
                            value={
                              formData.article6_texteprt1BTP ||
                              initialiserArticlesTexte(formData)
                                .article6_texteprt1BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article6" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article7_texte"
                            value={
                              formData.article7_texte ||
                              initialiserArticlesTexte(formData).article7_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article7_texteprt1"
                            value={
                              formData.article7_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article7_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article7_texteprt2"
                            value={
                              formData.article7_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article7_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article7" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article8_texte"
                            value={
                              formData.article8_texte ||
                              initialiserArticlesTexte(formData).article8_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article8_texteprt1"
                            value={
                              formData.article8_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article8_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article8_texteprt2"
                            value={
                              formData.article8_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article8_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article8_texteprt3"
                            value={
                              formData.article8_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article8_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article8" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article9_texteBTP"
                            value={
                              formData.article9_texteBTP ||
                              initialiserArticlesTexte(formData)
                                .article9_texteBTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article9_texteprt1BTP"
                            value={
                              formData.article9_texteprt1BTP ||
                              initialiserArticlesTexte(formData)
                                .article9_texteprt1BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article9_texteprt2BTP"
                            value={
                              formData.article9_texteprt2BTP ||
                              initialiserArticlesTexte(formData)
                                .article9_texteprt2BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article9" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article10_texte"
                            value={
                              formData.article10_texte ||
                              initialiserArticlesTexte(formData).article10_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article10_texteprt1"
                            value={
                              formData.article10_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article10_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article10_texteprt2"
                            value={
                              formData.article10_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article10_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article10_texteprt3"
                            value={
                              formData.article10_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article10_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article10" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article10_texte_cdd"
                            value={
                              formData.article10_texte_cdd ||
                              initialiserArticlesTexte(formData)
                                .article10_texte_cdd
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article11" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article11_texteBTP"
                            value={
                              formData.article11_texteBTP ||
                              initialiserArticlesTexte(formData)
                                .article11_texteBTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article11_texteprt1BTP"
                            value={
                              formData.article11_texteprt1BTP ||
                              initialiserArticlesTexte(formData)
                                .article11_texteprt1BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article11_texteprt2BTP"
                            value={
                              formData.article11_texteprt2BTP ||
                              initialiserArticlesTexte(formData)
                                .article11_texteprt2BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article11_texteprt3BTP"
                            value={
                              formData.article11_texteprt3BTP ||
                              initialiserArticlesTexte(formData)
                                .article11_texteprt3BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article11_texteprt4BTP"
                            value={
                              formData.article11_texteprt4BTP ||
                              initialiserArticlesTexte(formData)
                                .article11_texteprt4BTP
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article12" && (
                        <div>
                          <textarea
                            name="article12_texte"
                            value={
                              formData.article12_texte ||
                              initialiserArticlesTexte(formData).article12_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article13" && (
                        <div>
                          <textarea
                            name="article13_texte"
                            value={
                              formData.article13_texte ||
                              initialiserArticlesTexte(formData).article13_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",

                              border: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article14" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article14_texteprt1"
                            value={
                              formData.article14_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article14_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",

                              border: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article14_texteprt2"
                            value={
                              formData.article14_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article14_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",

                              border: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article15" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article15_texte"
                            value={
                              formData.article15_texte ||
                              initialiserArticlesTexte(formData).article15_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article15_texteprt1"
                            value={
                              formData.article15_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article15_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article15_texteprt2"
                            value={
                              formData.article15_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article15_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article15_texteprt3"
                            value={
                              formData.article15_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article15_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article16" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article16_texte"
                            value={
                              formData.article16_texte ||
                              initialiserArticlesTexte(formData).article16_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article16_texteprt1"
                            value={
                              formData.article16_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article16_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article16_texteprt2"
                            value={
                              formData.article16_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article16_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article16_texteprt3"
                            value={
                              formData.article16_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article16_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article16_texteprt4"
                            value={
                              formData.article16_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article16_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article16_texteprt5"
                            value={
                              formData.article16_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article16_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article16_texteprt6"
                            value={
                              formData.article16_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article16_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article17" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article17_texte"
                            value={
                              formData.article17_texte ||
                              initialiserArticlesTexte(formData).article17_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article17_texteprt1"
                            value={
                              formData.article17_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article17_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article18" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article18_texte"
                            value={
                              formData.article18_texte ||
                              initialiserArticlesTexte(formData).article18_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article18_texteprt1"
                            value={
                              formData.article18_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article18_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article18_texteprt2"
                            value={
                              formData.article18_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article18_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article18_texteprt3"
                            value={
                              formData.article18_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article18_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article18_texteprt4"
                            value={
                              formData.article18_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article18_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article18_texteprt5"
                            value={
                              formData.article18_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article18_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article18_texteprt6"
                            value={
                              formData.article18_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article18_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article19" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article19_texte"
                            value={
                              formData.article19_texte ||
                              initialiserArticlesTexte(formData).article19_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article19_texteprt1"
                            value={
                              formData.article19_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article19_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article20" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article20_texte"
                            value={
                              formData.article20_texte ||
                              initialiserArticlesTexte(formData).article20_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article20_texteprt1"
                            value={
                              formData.article20_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article20_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article20_texteprt2"
                            value={
                              formData.article20_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article20_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article20_texteprt3"
                            value={
                              formData.article20_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article20_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article20_texteprt4"
                            value={
                              formData.article20_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article20_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article20_texteprt5"
                            value={
                              formData.article20_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article20_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}

                      {key === "article21" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article21_texte"
                            value={
                              formData.article21_texte ||
                              initialiserArticlesTexte(formData).article21_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt1"
                            value={
                              formData.article21_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt2"
                            value={
                              formData.article21_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt3"
                            value={
                              formData.article21_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt4"
                            value={
                              formData.article21_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt5"
                            value={
                              formData.article21_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt6"
                            value={
                              formData.article21_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt7"
                            value={
                              formData.article21_texteprt7 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt7
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt8"
                            value={
                              formData.article21_texteprt8 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt8
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt9"
                            value={
                              formData.article21_texteprt9 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt9
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt10"
                            value={
                              formData.article21_texteprt10 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt10
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt11"
                            value={
                              formData.article21_texteprt11 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt11
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt12"
                            value={
                              formData.article21_texteprt12 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt12
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt13"
                            value={
                              formData.article21_texteprt13 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt13
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt14"
                            value={
                              formData.article21_texteprt14 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt14
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt15"
                            value={
                              formData.article21_texteprt15 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt15
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt16"
                            value={
                              formData.article21_texteprt16 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt16
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt17"
                            value={
                              formData.article21_texteprt17 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt17
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article21_texteprt18"
                            value={
                              formData.article21_texteprt18 ||
                              initialiserArticlesTexte(formData)
                                .article21_texteprt18
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article22" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article22_texte"
                            value={
                              formData.article22_texte ||
                              initialiserArticlesTexte(formData).article22_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt1"
                            value={
                              formData.article22_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt2"
                            value={
                              formData.article22_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt3"
                            value={
                              formData.article22_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt4"
                            value={
                              formData.article22_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt5"
                            value={
                              formData.article22_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt6"
                            value={
                              formData.article22_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt7"
                            value={
                              formData.article22_texteprt7 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt7
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt8"
                            value={
                              formData.article22_texteprt8 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt8
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt9"
                            value={
                              formData.article22_texteprt9 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt9
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt10"
                            value={
                              formData.article22_texteprt10 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt10
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt11"
                            value={
                              formData.article22_texteprt11 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt11
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt12"
                            value={
                              formData.article22_texteprt12 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt12
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt13"
                            value={
                              formData.article22_texteprt13 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt13
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article22_texteprt14"
                            value={
                              formData.article22_texteprt14 ||
                              initialiserArticlesTexte(formData)
                                .article22_texteprt14
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article23" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article23_texte"
                            value={
                              formData.article23_texte ||
                              initialiserArticlesTexte(formData).article23_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt1"
                            value={
                              formData.article23_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt2"
                            value={
                              formData.article23_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt3"
                            value={
                              formData.article23_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt4"
                            value={
                              formData.article23_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt5"
                            value={
                              formData.article23_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt6"
                            value={
                              formData.article23_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt7"
                            value={
                              formData.article23_texteprt7 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt7
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt8"
                            value={
                              formData.article23_texteprt8 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt8
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article23_texteprt9"
                            value={
                              formData.article23_texteprt9 ||
                              initialiserArticlesTexte(formData)
                                .article23_texteprt9
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article24" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article24_texte"
                            value={
                              formData.article24_texte ||
                              initialiserArticlesTexte(formData).article24_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt1"
                            value={
                              formData.article24_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt2"
                            value={
                              formData.article24_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt3"
                            value={
                              formData.article24_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt4"
                            value={
                              formData.article24_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt5"
                            value={
                              formData.article24_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt6"
                            value={
                              formData.article24_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt7"
                            value={
                              formData.article24_texteprt7 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt7
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt8"
                            value={
                              formData.article24_texteprt8 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt8
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article24_texteprt9"
                            value={
                              formData.article24_texteprt9 ||
                              initialiserArticlesTexte(formData)
                                .article24_texteprt9
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article25" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article25_texte"
                            value={
                              formData.article25_texte ||
                              initialiserArticlesTexte(formData).article25_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article25_texteprt1"
                            value={
                              formData.article25_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article25_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article25_texteprt2"
                            value={
                              formData.article25_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article25_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article25_texteprt3"
                            value={
                              formData.article25_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article25_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article26" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article26_texte"
                            value={
                              formData.article26_texte ||
                              initialiserArticlesTexte(formData).article26_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article26_texteprt1"
                            value={
                              formData.article26_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article26_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article26_texteprt2"
                            value={
                              formData.article26_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article26_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article26_texteprt3"
                            value={
                              formData.article26_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article26_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article26_texteprt4"
                            value={
                              formData.article26_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article26_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article26_texteprt5"
                            value={
                              formData.article26_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article26_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article27" && (
                        <div
                          style={{
                            width: "80%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <textarea
                            name="article27_texte"
                            value={
                              formData.article27_texte ||
                              initialiserArticlesTexte(formData).article27_texte
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article27_texteprt1"
                            value={
                              formData.article27_texteprt1 ||
                              initialiserArticlesTexte(formData)
                                .article27_texteprt1
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article27_texteprt2"
                            value={
                              formData.article27_texteprt2 ||
                              initialiserArticlesTexte(formData)
                                .article27_texteprt2
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article27_texteprt3"
                            value={
                              formData.article27_texteprt3 ||
                              initialiserArticlesTexte(formData)
                                .article27_texteprt3
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article27_texteprt4"
                            value={
                              formData.article27_texteprt4 ||
                              initialiserArticlesTexte(formData)
                                .article27_texteprt4
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article27_texteprt5"
                            value={
                              formData.article27_texteprt5 ||
                              initialiserArticlesTexte(formData)
                                .article27_texteprt5
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                          <textarea
                            name="article27_texteprt6"
                            value={
                              formData.article27_texteprt6 ||
                              initialiserArticlesTexte(formData)
                                .article27_texteprt6
                            }
                            onChange={handleInputChange}
                            rows={3}
                            style={{
                              width: "100%",
                              border: "none",
                              resize: "none",
                              outline: "none",
                              fontSize: "12px",
                            }}
                          />
                        </div>
                      )}
                      {key === "article28" && (
                        <>
                          <textarea
                            name="article28_texte_cdd"
                            value={
                              formData.article28_texte_cdd ||
                              initialiserArticlesTexte(formData)
                                .article28_texte_cdd
                            }
                            onChange={handleInputChange}
                            rows={5}
                            style={{ width: "100%" }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="ContratType">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                marginTop: "40px",
                marginBottom: "5px",
              }}
            >
              <div
                style={{
                  marginRight: "40px",
                }}
              >
                <label>
                  Civilité :&nbsp;
                  <select
                    name="civilite"
                    value={formData.civilite}
                    onChange={handleInputChange}
                  >
                    <option value="Monsieur">Monsieur</option>
                    <option value="Madame">Madame</option>
                  </select>
                </label>
                <label>
                  Nom du salarié:&nbsp;
                  <input
                    type="text"
                    name="nom_salarie"
                    value={formData.nom_salarie}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Date de naissance:&nbsp;
                  <input
                    type="text"
                    name="date_de_naissance"
                    value={formData.date_de_naissance}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Lieu de naissance:&nbsp;
                  <input
                    type="text"
                    name="lieu_de_naissance"
                    value={formData.lieu_de_naissance}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Adresse:&nbsp;
                  <input
                    type="text"
                    name="adresse"
                    value={formData.adresse}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Sécurité Sociale:&nbsp;
                  <input
                    type="text"
                    name="securtie_sociale"
                    value={formData.securtie_sociale}
                    onChange={handleInputChange}
                    maxLength={25}
                    inputMode="numeric"
                    placeholder="X XX XX XX XXX XXX XX"
                  />
                </label>
                <label>
                  Nationalite:&nbsp;
                  <input
                    type="text"
                    name="nationalite"
                    value={formData.nationalite}
                    onChange={handleInputChange}
                  />
                </label>
              </div>
              <div>
                <label>
                  Dossier:&nbsp;
                  <input
                    type="text"
                    name="dossier"
                    value={formData.dossier}
                    onChange={handleInputChange}
                    placeholder="Monsieur ..."
                  />
                </label>

                <label>
                  Dirigeant du Dossier:&nbsp;
                  <input
                    type="text"
                    name="dossier_dirigeant"
                    value={formData.dossier_dirigeant}
                    onChange={handleInputChange}
                  />
                </label>

                <label>
                  Qualité du Dirigeant:&nbsp;
                  <input
                    type="text"
                    name="qualite_dirigeant"
                    value={formData.qualite_dirigeant}
                    onChange={handleInputChange}
                  />
                </label>

                <label>
                  Lieu de Dossier:&nbsp;
                  <input
                    type="text"
                    name="lieu_dossier"
                    value={formData.lieu_dossier}
                    onChange={handleInputChange}
                  />
                </label>

                <label>
                  Siret:&nbsp;
                  <input
                    type="text"
                    name="siret_dossier"
                    value={formData.siret_dossier}
                    onChange={handleInputChange}
                  />
                </label>

                <label>
                  APE:&nbsp;
                  <input
                    type="text"
                    name="ape_dossier"
                    value={formData.ape_dossier}
                    onChange={handleInputChange}
                  />
                </label>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  marginRight: "40px",
                }}
              >
                <label>
                  Poste:&nbsp;
                  <input
                    type="text"
                    name="poste"
                    value={formData.poste}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Echelon CCN :&nbsp;
                  <select
                    name="echelon_ccn"
                    value={formData.echelon_ccn}
                    onChange={handleInputChange}
                  >
                    <option value="">-- Sélectionnez un CCN --</option>
                    <option value="Convention collective du « Bâtiment et travaux publics de la Réunion » (Réf. IDCC 2389). ">
                      IDCC 2389
                    </option>
                    <option value="Convention collective des entreprises d’architecture (Réf. IDCC 3062).">
                      IDCC 3062
                    </option>
                    <option value="Convention collective des Hôtels, Cafés, restaurant (Réf. IDCC 1979).">
                      IDCC 1979
                    </option>
                  </select>
                </label>
              </div>
              <div>
                <label>
                  Début CDD :&nbsp;
                  <input
                    type="date"
                    name="debut_cdd"
                    value={formData.debut_cdd}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Fin CDD :&nbsp;
                  <input
                    type="date"
                    name="fin_cdd"
                    value={formData.fin_cdd}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Motif du CDD :&nbsp;
                  <select
                    name="motif_cdd"
                    value={formData.motif_cdd}
                    onChange={handleInputChange}
                  >
                    <option value="">-- Motif du CDD --</option>
                    <option value="Remplacement d'un salarié absent ">
                      Remplacement
                    </option>
                    <option value="Attente de la suppression définitive du poste du salarié ayant quitté définitivement l'entreprise">
                      Attente de suppression
                    </option>
                    <option value="Accroissement temporaire de l'activité de l'entreprise">
                      Accroissement temporaire
                    </option>
                    <option value="Emplois à caractère saisonnier">
                      Caratctère saisonnier
                    </option>
                    <option value="Contrats à durée déterminée « d'usage »">
                      Contre d'usage
                    </option>
                  </select>
                </label>
                <p style={{ fontSize: "12px" }}>
                  Durée CDD : {formData.duree_cdd}
                </p>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  marginRight: "40px",
                }}
              >
                <label>
                  Durréer période d'essai ( en jours ):&nbsp;
                  <input
                    type="number"
                    name="durre_pressai_cdd"
                    value={formData.durre_pressai_cdd}
                    onChange={handleInputChange}
                  />{" "}
                </label>

                <label>
                  Date fin période d’essai :&nbsp;
                  <input
                    type="date"
                    name="date_fin_pressai"
                    value={formData.date_fin_pressai}
                    onChange={handleInputChange}
                  />
                </label>

                {include.article3 && (
                  <label>
                    Durréer renouvellement:&nbsp;
                    <input
                      type="number"
                      name="durre_renouv"
                      value={formData.durre_renouv}
                      onChange={handleInputChange}
                    />
                  </label>
                )}
              </div>
              <div>
                {" "}
                <label>
                  Lieu de traivail:&nbsp;
                  <input
                    type="text"
                    name="lieu_travail"
                    value={formData.lieu_travail}
                    onChange={handleInputChange}
                  />
                </label>
                {include.article7 && (
                  <label>
                    jour avant déplacement (mobilité):&nbsp;
                    <input
                      type="number"
                      name="jour_mobilite"
                      value={formData.jour_mobilite}
                      onChange={handleInputChange}
                    />
                  </label>
                )}{" "}
                <label>
                  Heure par Semaine:&nbsp;
                  <input
                    type="number"
                    name="heure_semaine"
                    value={formData.heure_semaine}
                    onChange={handleInputChange}
                  />
                </label>{" "}
                <label>
                  Heure par Mois:&nbsp;
                  <input
                    type="text"
                    name="heure_mois"
                    value={formData.heure_mois}
                    onChange={handleInputChange}
                  />
                </label>
                <label>
                  Rémunération
                  <input
                    type="text"
                    name="remuneration_chiffre"
                    placeholder="00,00"
                    value={formData.remuneration_chiffre}
                    onChange={(e) => {
                      let raw = e.target.value
                        .replace(",", ".")
                        .replace(/[^\d.]/g, "");
                      if (raw === "") {
                        setFormData({ ...formData, remuneration_chiffre: "" });
                        return;
                      }

                      let num = parseFloat(raw);
                      if (!isNaN(num)) {
                        const parts = raw.split(".");
                        let formatted =
                          parts.length === 2
                            ? parts[0] + "," + parts[1].substring(0, 2)
                            : parts[0];
                        setFormData({
                          ...formData,
                          remuneration_chiffre: formatted,
                        });
                      }
                    }}
                    onBlur={() => {
                      let input = formData.remuneration_chiffre
                        .replace(",", ".")
                        .replace(/[^\d.]/g, "");
                      let num = parseFloat(input);
                      if (!isNaN(num)) {
                        let formatted = num.toFixed(2).replace(".", ",");
                        setFormData({
                          ...formData,
                          remuneration_chiffre: formatted,
                          remuneration: convertirMontantEnLettres(formatted),
                        });
                      } else {
                        setFormData({
                          ...formData,
                          remuneration_chiffre: "",
                          remuneration: "",
                        });
                      }
                    }}
                  />
                </label>
                <p style={{ margin: 0, fontSize: "12px" }}>
                  {formData.remuneration}
                </p>
              </div>
            </div>

            <div>
              {include.article10 && (
                <>
                  {" "}
                  <label>
                    Mois pour le 13eme mois:&nbsp;
                    <input
                      type="text"
                      name="date_13eme_mois"
                      value={formData.date_13eme_mois}
                      onChange={handleInputChange}
                    />
                    <br />
                  </label>
                </>
              )}
              {include.article18 && (
                <>
                  {" "}
                  <label>
                    Montant de pénalité:&nbsp;
                    <input
                      type="number"
                      name="montant_penalites"
                      value={formData.montant_penalites}
                      onChange={handleInputChange}
                    />
                    <br />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
